import { useMutation } from 'react-query';
import { AxiosResponse } from 'axios';

// configs
import { API } from 'configs/api';

const updateStatsHotspotMutation = async ({
  data,
  shortUrl,
}: {
  data: { hotSpotData: string; viewerId: number };
  shortUrl: string;
}) => {
  const response: AxiosResponse = await API.put(
    `/playback/${shortUrl}/hotspot`,
    data
  );

  return response.data;
};

export const useUpdateStatsHotspotMutation = () => {
  return useMutation(updateStatsHotspotMutation);
};
